import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { steps } from '../../data/content';
export function HowItWorksSection() {
  return <section aria-labelledby="steps-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-118" data-mp="37tgpw53umsts">
      <div className="mx-auto max-w-5xl" data-id="element-119" data-mp="3csjyfzj1fh6i">
        <SectionHeading id="steps-heading" title={<>
              Get Started in <Accent data-id="element-121" data-mp="3lrx6cnrijxp4">3 Simple Steps</Accent>
            </>} data-id="element-120" data-mp="3hq3d30jndvyz" />

        <ol className="relative mt-12 grid gap-10 md:grid-cols-3 md:gap-8" role="list" data-id="element-122" data-mp="3qpysjhk8kd4t">
          <span aria-hidden="true" className="absolute left-[10%] right-[10%] top-6 hidden h-px bg-brand-gold/40 md:block" data-id="element-123" data-mp="3vgylkbq8ib21" />
          {steps.map((step, index) => <li key={step.title} className="relative flex flex-col items-center text-center" data-id="element-124" data-mp="99qp5yxalei5" data-mpi={index}>
              <span className="flex h-12 w-12 items-center justify-center rounded-full border border-brand-gold/50 bg-brand-ivory font-display text-[1.3rem] font-bold text-brand-gold-dark" data-id="element-125" data-mp="dbbv10bessiu">
                {index + 1}
              </span>
              <h3 className="mt-5 font-display text-[1.3rem] font-bold leading-tight text-brand-charcoal" data-id="element-126" data-mp="2u6rn08h5rpvz">
                {step.title}
              </h3>
              <p className="mt-2 max-w-[280px] text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-127" data-mp="2pajaz3y9cct1">{step.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}